const { renderWishlist } =
  await import(`./render-wishlist.js?v=${Date.now()}`);
import "./index.js";
import "./_commonjsHelpers.js";
import "./recommended-products.js";
import "./pricing.js";
class WishlistTemplate extends HTMLElement {
  constructor() {
    super();
    const grid = this.querySelector(".wishlist__grid");
    const wishlist = JSON.parse(localStorage.getItem("Suite702_wishlist"));
    const renderEmptyState = () => {
      return `
        <div class="wishlist__empty">
          <h2>${window.wishlist.no_items}</h2>
          <p>${window.wishlist.add_items_to_wishlist}</p>
        </div>
      `;
    };
    if (wishlist) {
      renderWishlist(wishlist, grid);
    } else {
      setTimeout(() => {
        grid.innerHTML = renderEmptyState();
      }, 1e3);
    }
  }
}
if (customElements.get("wishlist-template") === void 0) {
  customElements.define("wishlist-template", WishlistTemplate);
}
